import { ModalContent } from '@/components/Modal'

import { ExportOrderSource } from '..'
import { useConfigureController } from '../hooks/useController'
import { Body } from './Body'
import { Footer } from './Footer/Footer'
import { Header } from './Header'
import { InvalidBody } from './InvalidBody'
import { InvalidFooter } from './InvalidFooter'
import { InvalidHeader } from './InvalidHeader'

type ContentProps = {
  source: ExportOrderSource
  orderStepIds: string[]
  orderSteps: uui.domain.client.rm.ExtendedOrderStep[]
  planType: 'archived' | 'none' | 'simulation' | 'operations'
  date?: string
}

export function Content({ source, orderStepIds, orderSteps, planType, date }: ContentProps) {
  const { ready, invalid } = useConfigureController(
    planType,
    source,
    orderStepIds,
    orderSteps,
    date,
  )

  if (!ready) return null

  if (invalid) {
    return (
      <ModalContent header={<InvalidHeader />} footer={<InvalidFooter />}>
        <InvalidBody />
      </ModalContent>
    )
  }

  return (
    <ModalContent header={<Header />} footer={<Footer />} minWidth={1030}>
      {invalid ? <InvalidBody /> : <Body />}
    </ModalContent>
  )
}
